import React from 'react';
import defaultAvatar from '../../assets/images/defaultImages/defaultAvatar.png';
export default function CustomUserAvatar({srcPath}){
    return(
        <img className="table-user-img" src={srcPath || defaultAvatar} />
    );
}